import { BoatCoverage } from "Store/interfaces/products/coverage";
import { BoatProductPriceFormValues } from "./ProductPrice/boatProductPriceInterfaces";
import {
  DEFAULT_DEDUCTIBLE_BOAT,
  DEFAULT_DEDUCTIBLE_SMALL_BOAT,
} from "./boatConstants";

export const getSetDeductible = (
  coverage: BoatCoverage,
): string | undefined => {
  switch (coverage) {
    case BoatCoverage.BOAT_SAILING_BOAT_REDUCED_OWN_DAMAGE:
    case BoatCoverage.BOAT_MOTOR_REDUCED_OWN_DAMAGE:
      return DEFAULT_DEDUCTIBLE_BOAT;
    case BoatCoverage.BOAT_ROWBOAT_CANOE_KAYAK_FULL_OWN_DAMAGE:
      return DEFAULT_DEDUCTIBLE_SMALL_BOAT;
  }
  return undefined;
};

export const getDeductible = (
  formValues: BoatProductPriceFormValues,
): string | undefined => {
  const coverage = formValues.coverage;
  if (
    coverage === BoatCoverage.BOAT_SAILING_BOAT_REDUCED_OWN_DAMAGE ||
    coverage === BoatCoverage.BOAT_MOTOR_REDUCED_OWN_DAMAGE ||
    coverage === BoatCoverage.BOAT_ROWBOAT_CANOE_KAYAK_REDUCED_OWN_DAMAGE
  ) {
    return "Se vilkår";
  }
  return formValues.deductible;
};
